module.exports = __webpack_public_path__ + "img/mb_hm_block01_sc.de0dae84.jpg";